(function () {
  "use strict";

  var MIN_QUERY_LENGTH = 2;
  var documentClickBound = false;

  function getLiveWrapper() {
    return document.querySelector("[data-predictive-search]");
  }

  function closeResultsFor(wrapper) {
    var input = wrapper.querySelector("[data-predictive-search-input]");
    var resultsEl = wrapper.querySelector("[data-predictive-search-results]");
    if (!input || !resultsEl) return;
    resultsEl.setAttribute("hidden", "");
    input.setAttribute("aria-expanded", "false");
    input.removeAttribute("aria-activedescendant");
  }

  function bindDocumentClickOnce() {
    if (documentClickBound) return;
    documentClickBound = true;
    document.addEventListener("click", function (evt) {
      var wrapper = getLiveWrapper();
      if (!wrapper) return;
      if (!wrapper.contains(evt.target)) {
        closeResultsFor(wrapper);
      }
    });
  }

  function initPredictiveSearch(root) {
    var wrapper = root.querySelector("[data-predictive-search]");
    if (!wrapper || wrapper.dataset.predictiveSearchInitialized === "true") return;
    wrapper.dataset.predictiveSearchInitialized = "true";

    var input = wrapper.querySelector("[data-predictive-search-input]");
    var resultsEl = wrapper.querySelector("[data-predictive-search-results]");
    if (!input || !resultsEl) return;

    var sectionId = wrapper.dataset.predictiveSearchSectionId;

    var currentController = null;
    var requestSequence = 0;
    var activeIndex = -1;

    function cancelPendingRequest() {
      if (currentController) {
        currentController.abort();
        currentController = null;
      }
    }

    function getOptions() {
      return Array.prototype.slice.call(resultsEl.querySelectorAll('[role="option"]'));
    }

    function clearActiveOption() {
      var options = getOptions();
      options.forEach(function (opt) {
        opt.classList.remove("is-active");
      });
      input.removeAttribute("aria-activedescendant");
      activeIndex = -1;
    }

    function setActiveOption(index) {
      var options = getOptions();
      if (!options.length) return;

      if (index < 0) index = options.length - 1;
      if (index >= options.length) index = 0;

      options.forEach(function (opt) {
        opt.classList.remove("is-active");
      });

      var target = options[index];
      target.classList.add("is-active");
      target.scrollIntoView({ block: "nearest" });
      input.setAttribute("aria-activedescendant", target.id);
      activeIndex = index;
    }

    function openResults() {
      resultsEl.removeAttribute("hidden");
      input.setAttribute("aria-expanded", "true");
    }

    function closeResults() {
      cancelPendingRequest();
      resultsEl.setAttribute("hidden", "");
      input.setAttribute("aria-expanded", "false");
      clearActiveOption();
    }

    function showLoading() {
      var loadingLabel = (Naghmah.strings && Naghmah.strings.searching) || "...";
      resultsEl.innerHTML =
        '<div class="predictive-search__loading">' +
        '<span class="icon icon--spin" aria-hidden="true"></span>' +
        "<span>" + loadingLabel + "</span>" +
        "</div>";
      openResults();
    }

    function fetchResults(term) {
      if (!Naghmah.routes || !Naghmah.routes.predictiveSearch) return;
      if (!sectionId) return;

      cancelPendingRequest();
      currentController = window.AbortController ? new AbortController() : null;
      requestSequence += 1;
      var thisRequest = requestSequence;

      var url =
        Naghmah.routes.predictiveSearch +
        "?q=" + encodeURIComponent(term) +
        "&section_id=" + encodeURIComponent(sectionId) +
        "&resources[type]=product,collection,page" +
        "&resources[limit]=6" +
        "&resources[options][unavailable_products]=last";

      fetch(url, currentController ? { signal: currentController.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error("predictive-search request failed");
          return response.text();
        })
        .then(function (html) {
          if (thisRequest !== requestSequence) return;
          if (input.value.trim() !== term) return;

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var serverResults = doc.querySelector("#predictive-search-results");
          resultsEl.innerHTML = serverResults ? serverResults.innerHTML : "";
          clearActiveOption();
          openResults();
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") return;
          if (thisRequest !== requestSequence) return;
          resultsEl.innerHTML = "";
          closeResults();
        });
    }

    var onInput = Naghmah.debounce(function () {
      var term = input.value.trim();
      if (term.length < MIN_QUERY_LENGTH) {
        cancelPendingRequest();
        closeResults();
        resultsEl.innerHTML = "";
        return;
      }
      showLoading();
      fetchResults(term);
    }, 300);

    input.addEventListener("input", onInput);

    input.addEventListener("focus", function () {
      if (input.value.trim().length >= MIN_QUERY_LENGTH && resultsEl.innerHTML.trim() !== "") {
        openResults();
      }
    });

    input.addEventListener("keydown", function (evt) {
      var options = getOptions();

      if (evt.key === "Escape") {
        closeResults();
        input.blur();
        return;
      }

      if (!options.length || resultsEl.hasAttribute("hidden")) return;

      if (evt.key === "ArrowDown") {
        evt.preventDefault();
        setActiveOption(activeIndex + 1);
      } else if (evt.key === "ArrowUp") {
        evt.preventDefault();
        setActiveOption(activeIndex - 1);
      } else if (evt.key === "Enter") {
        if (activeIndex > -1 && options[activeIndex]) {
          evt.preventDefault();
          window.location.href = options[activeIndex].href;
        }
      }
    });

    bindDocumentClickOnce();
  }

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  if (Naghmah.registerSection) {
    Naghmah.registerSection("header", initPredictiveSearch);
  }

  Naghmah.onReady(function () {
    var header = document.querySelector('[data-section-type="header"]');
    if (header) initPredictiveSearch(header);
  });
})();
